'use strict';

angular.module('paizacloudApp')
  .directive('flexSplitPaneDivider', function() {
    return {
      templateUrl: 'app/flex-split-pane-divider/flex-split-pane-divider.html',
      restrict: 'EA',
      replace: true,
      scope: {
        shrink: '=',
        grow: '=',
        shrinkElement: '@',
        growElement: '@',
        direction: '@',
        onMove: '&',
      },
      link: function(scope, element, attrs) {
        scope.mousedown = function(ev){
          ev.stopPropagation();
          ev.preventDefault();

          ev = (ev.targetTouches && ev.targetTouches.length === 1) ? ev.targetTouches[0] : ev;

          let prevPos = (scope.direction === 'horizontal' ? ev.pageY : ev.pageX);

          function onMove(ev2){
            ev2.stopPropagation();
            ev2.preventDefault();

            ev2 = (ev2.targetTouches && ev2.targetTouches.length === 1) ? ev2.targetTouches[0] : ev2;

            scope.$apply(() => {
              let pagePos = (scope.direction === 'horizontal' ? ev2.pageY : ev2.pageX);
              let diff = pagePos - prevPos;
              if(diff < 0){
                if(scope.grow < -diff){
                  diff = - scope.grow;
                }
                let growElement = element.parent().find(scope.growElement);
                let size = <number>((scope.direction === 'horizontal') ? growElement.height() : growElement.width());
                if(growElement.length > 0 && size < -diff){
                  diff = - size;
                }
              }else if(diff > 0){
                if(scope.shrink < diff){
                  diff = scope.shrink;
                }
                let shrinkElement = element.parent().find(scope.shrinkElement);
                let size = <number>((scope.direction === 'horizontal') ? shrinkElement.height() : shrinkElement.width());
                if(shrinkElement.length > 0 && size < diff){
                  diff = size;
                }
              }
              if(scope.shrink !== undefined){
                scope.shrink -= diff;
              }
              if(scope.grow !== undefined){
                scope.grow += diff;
              }
              prevPos += diff;
            });
          }
          $(document).on('mousemove touchmove', onMove);
          $(document).one('mouseup touchend', (event) => {
            $(document).off('mousemove touchmove', onMove);
            if(scope.onMove){
              scope.$apply(() => {
                scope.onMove({$event: event});
              });
            }
          });
        };
      },
    };
  });
